import * as React from 'react';
import { FilterBar } from 'components/PortalStructure';
require('./style.css');

interface IProps {
	filterBarOptions?: any;
	childIsList?: boolean;
}

class FilteredPage extends React.Component<IProps, any> {
	public static defaultProps: Partial<IProps> = {
		childIsList: true,
	};

	/* RENDER */
	public render() {
		const { filterBarOptions, children, childIsList } = this.props;

		let classes = `filteredPage filteredListPage`;
		if (!childIsList) {
			classes = 'filteredPage';
		}

		return (
			<div className={classes}>
				<FilterBar {...filterBarOptions} />
				<div className="filteredPageContainer">
					<div className="filteredPageInnerHolder">{children}</div>
				</div>
			</div>
		);
	}
}
export { FilteredPage };
